import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject, debounceTime, fromEvent, takeUntil } from 'rxjs';

export interface Menu {
  headTitle1?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  level?: number;
  children?: Menu[];
}

@Injectable({
  providedIn: 'root',
})

export class NavService {

  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  public collapseSidebar: boolean = window.innerWidth < 1200 ? true : false;
  private unsubscribe: Subject<any> = new Subject();

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(0), takeUntil(this.unsubscribe))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 1200) {
          this.collapseSidebar = true;
        } else {
          this.collapseSidebar = false;
        }
      });
  }

  updateMenuItems() {
    let stringItems = JSON.stringify(this.MENUITEMSALL);
    let clonedItems = JSON.parse(stringItems);  // Clona el array superficialmente
    this.items.next(clonedItems);
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
        .pipe(debounceTime(0), takeUntil(this.unsubscribe))
        .subscribe((evt: any) => {
          this.setScreenWidth(evt.target.innerWidth);
          if (evt.target.innerWidth < 1200) {
            this.collapseSidebar = true;
          } else {
            this.collapseSidebar = false;
          }
        });
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: any[] = [];
  MENUITEMSALL: any[] = [
    // {
    //   headTitle1: "admin",
    //   module: "rol_admin"
    // },
    {
      level: 1,
      title: "catalogs",
      icon: "widget",
      type: "sub",
      active: true,
      children: [
        { path: "/admin/rol", title: "Roles", icon: "user", type: "link", module: "Roles" },
        { path: "/admin/user", title: "Usuarios", type: "link", module: "Usuarios" },
        { path: "/admin/client", title: "Clientes", type: "link", module: "Clientes" },
        { path: "/admin/catalog", title: "Catalogos", type: "link", module: "Catálogos" },
        { path: "/admin/route", title: "Rutas", type: "link", module: "Rutas" },
        { path: "/admin/employee", title: "Trasladistas", type: "link", module: "Trasladista" }
      ],
      module: ""
    },
    // {
    //   headTitle1: "service",
    //   module: "rol_admin"
    // },
    {
      level: 1,
      title: "Flota",
      icon: "icons",
      type: "sub",
      active: true,
      children: [
        { path: "/vehicle/management", title: "Gestión", type: "link", module: "Gestión" },
        { path: "/vehicle/dashboard", title: "Vehículos", type: "link", module: "Tablero Vehículos" },
        { path: "/vehicle/category", title: "Categorías", type: "link", module: "Categoría" },
        { path: "/vehicle/movements", title: "Entradas y Salidas", type: "link", module: "Entradas y Salidas" },
        { path: "/vehicle/inspection", title: "Hoja de inspección", type: "link", module: "Hoja de inspección" },
        { path: "/vehicle/maintenance", title: "Mantenimiento", type: "link", module: "Mantenimiento" },
      ],
      module: ""
    },
    { level: 1, path: "profile/client", title: "Perfil", icon: "sample-page", type: "link", module: "rol_client" },

    {
      level: 1,
      title: "Cotizar/Reservar",
      icon: "blog",
      type: "sub",
      active: true,
      children: [
        { path: "/service/new", title: "Nuevo servicio", type: "link", module: "rol_client" },
        { path: "/service/backlog", title: "BackLog", type: "link", module: "Backlog" },
        { path: "/service/canceled", title: "Cancelados", type: "link", module: "Cancelados" },
        { path: "/service/list", title: "Servicios", type: "link", module: "Lista" },
        { path: "/service/event", title: "Eventos", type: "link", module: "Eventos" },
        { path: "/service/task", title: "Tareas", type: "link", module: "Tareas" },
        { path: "/service/company", title: "Empresas", type: "link", module: "Empresas" },
      ],
      module: ""
    },
    // { level: 1, path: "/single-page", title: "otro", icon: "sample-page", type: "link", module: "" },
  ];

  items = new BehaviorSubject<any[]>(this.MENUITEMS);

}


